class Utilities {
    public static getComponentValueByType( type: string, components: google.maps.GeocoderAddressComponent[], long = false ): string {
        const component = Utilities.getComponentByType( type, components );

        if ( long ) {
            return component?.long_name ?? '';
        }

        return Utilities.getComponentByType( type, components )?.short_name ?? '';
    }

    public static getFirstComponentValueByType( types: Array<string>, components: google.maps.GeocoderAddressComponent[] ): string {
        const values = types.map( ( type ) => Utilities.getComponentValueByType( type, components, true ) );

        return values.find( ( value ) => value !== '' ) ?? '';
    }

    public static getComponentByType( type: string, components: google.maps.GeocoderAddressComponent[] ): google.maps.GeocoderAddressComponent | undefined {
        return components.find( ( { types } ) => types[ 0 ] === type );
    }

    // The returned array from Google for the types is not always stable, so the correct behaviour would be to check for the type anywhere in the array of types.
    // However, given how long the above code has been in use, and how the default strategy uses these functions already, we will gradually migrate to this new functions
    // as and when merchants encounter issues.
    public static getComponentValueByUnsortedType( type: string, components: google.maps.GeocoderAddressComponent[], long = false ): string {
        const component = Utilities.getComponentByUnsortedType( type, components );

        if ( long ) {
            return component?.long_name ?? '';
        }

        return component?.short_name ?? '';
    }

    public static getFirstComponentValueByUnsortedType( types: Array<string>, components: google.maps.GeocoderAddressComponent[] ): string {
        const values = types.map( ( type ) => Utilities.getComponentValueByUnsortedType( type, components, true ) );

        return values.find( ( value ) => value !== '' ) ?? '';
    }

    public static getComponentByUnsortedType( type: string, components: google.maps.GeocoderAddressComponent[] ): google.maps.GeocoderAddressComponent | undefined {
        return components.find( ( { types } ) => types.includes( type ) );
    }
}

export default Utilities;
